module.exports = __webpack_public_path__ + "static/media/logout.32e5d155.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logout.png
// module id = 1630
// module chunks = 0